import React, {useState, useMemo, useEffect} from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import Toggle from '../../Button/Toggle';
import Text from '../../Formatting/Text';

const fallbackValue = null;

const allowedTriggers = [
    {
        value: 'SendNotifications',
        label: 'Send notifications',
        help: 'Send the customer a notification\n(if enabled in More > Customers > Notifications)'
    },
    {
        value: 'Invoice',
        label: 'Create invoice',
        help: 'Create an invoice and deduct the job cost from the customer balance'
    },
    {
        value: 'Charge',
        label: 'Charge customer',
        help: 'Charge the customer\'s saved payment methods (if any) for the job cost'
    },
    {
        value: 'LoyaltyCards',
        label: 'Update loyalty cards',
        help: 'Add points to or redeem loyalty cards (if any)'
    },
]

const EventTriggers = ({
    label = 'Triggers',
    name = 'eventTriggers',
    help,
    onChange,
    triggers,
    disabled,
    validators,
    footer,
}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    let value = formData[name] ?? fallbackValue;
    const {isValid, error} = useValidators(value, validators, name, updateValidity);
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        handleChange(enabled ? triggers : null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled]);

    const handleChange = (state) => {
        updateField(name, state);
        onChange && onChange(state);
    }

    const options = useMemo(() => {
        return allowedTriggers.filter(t => triggers.includes(t.value));
    }, [triggers]);

    const toggle = (e) => {
        let val = Array.isArray(value) ? value : [];

        const index = val.indexOf(e);
        if (index > -1) {
            val = val.filter((v, i) => i !== index);
        } else {
            val = [...val, e];
        }

        handleChange(val);
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled, footer}}>
        <Toggle {...{label: `Limit which actions are triggered`, enabled, onChange: setEnabled, disabled: isDisabled}} />

        {enabled && <TheTriggers {...{label, options, toggle, value, name, isDisabled}} />}

    </CommonFieldWrapper>
}

const TheTriggers = ({label, options, toggle, value, name, isDisabled}) => {
    return <fieldset className="px-2">
        <legend className="sr-only">{label}</legend>
        <div className="space-y-3 mt-2 overflow-y-auto max-h-[25vh]">
            {options.map((option, index) => {
                return <div className="relative flex items-start" key={option.label+option.value+index}>
                    <div className="flex h-6 items-center">
                        <input
                            id={'checkbox-'+option.value}
                            aria-describedby={'desc-'+option.value}
                            name={name}
                            type="checkbox"
                            className="ml-1 h-4 w-4 rounded-sm border-gray-300 text-brand focus:ring-brand disabled:bg-gray-200"
                            checked={value && value.indexOf(option.value) > -1}
                            onChange={() => toggle(option.value)}
                            disabled={isDisabled}
                        />
                    </div>
                    <div className="ml-3 text-sm leading-6">
                        <label htmlFor={'checkbox-'+option.value} className="font-medium">
                            {option.label}
                        </label>
                        <p id={'desc-'+option.value} className="text-muted leading-snug">
                            <Text text={option.help} />
                        </p>
                    </div>
                </div>
            })}
        </div>
    </fieldset>
}

export default EventTriggers;
